import { MIMETYPE_XLSX } from '@disy/lib/media-type';

import { AbstractDataViewExportAction } from 'cadenza/actions/table/abstract-data-view-export-action';
import type { ExportActionContext } from 'cadenza/workbook/actions/export-actions';
import type { DataViewId } from 'cadenza/workbook/model/data-view-id.gen';

import i18n from './export-to-xlsx-action.properties';

export class ExportToXlsxAction extends AbstractDataViewExportAction {
  constructor(dataViewId: DataViewId, actionContext: ExportActionContext) {
    super(dataViewId, actionContext, MIMETYPE_XLSX, {
      label: i18n('action.label'),
      dialogTitle: i18n('dialog.title'),
    });
  }

  override get enabledSync() {
    return true;
  }
}
